export const LOAD_ACTION_FOR_EDITING =
  "bonfire/_BETA/action/LOAD_ACTION_FOR_EDITING";

export const LOAD_COMMENTS = "bonfire/_BETA/action/LOAD_COMMENTS";
export const LOAD_COMMENTS_REQUEST =
  "bonfire/_BETA/action/LOAD_COMMENTS_REQUEST";
export const LOAD_COMMENTS_REQUEST_SUCCESS =
  "bonfire/_BETA/action/LOAD_COMMENTS_REQUEST_SUCCESS";
export const LOAD_COMMENTS_REQUEST_FAIL =
  "bonfire/_BETA/action/LOAD_COMMENTS_REQUEST_FAIL";

export const LOAD_ACTION = "bonfire/_BETA/action/LOAD_ACTION";
export const LOAD_ACTION_REQUEST = "bonfire/_BETA/action/LOAD_ACTION_REQUEST";
export const LOAD_ACTION_REQUEST_SUCCESS =
  "bonfire/_BETA/action/LOAD_ACTION_REQUEST_SUCCESS";
export const LOAD_ACTION_REQUEST_FAIL =
  "bonfire/_BETA/action/LOAD_ACTION_REQUEST_FAIL";

export const SAVE_ACTION = "bonfire/_BETA/action/SAVE_ACTION";
export const SAVE_ACTION_REQUEST = "bonfire/_BETA/action/SAVE_ACTION_REQUEST";
export const SAVE_ACTION_REQUEST_SUCCESS =
  "bonfire/_BETA/action/SAVE_ACTION_REQUEST_SUCCESS";
export const SAVE_ACTION_REQUEST_FAIL =
  "bonfire/_BETA/action/SAVE_ACTION_REQUEST_FAIL";

export const ADD_ACTION = "bonfire/_BETA/action/ADD_ACTION";
export const ADD_ACTION_REQUEST = "bonfire/_BETA/action/ADD_ACTION_REQUEST";
export const ADD_ACTION_REQUEST_SUCCESS =
  "bonfire/_BETA/action/ADD_ACTION_REQUEST_SUCCESS";
export const ADD_ACTION_REQUEST_FAIL =
  "bonfire/_BETA/action/ADD_ACTION_REQUEST_FAIL";

export const LOAD_RULES = "bonfire/_BETA/action/LOAD_RULES";
export const LOAD_RULES_REQUEST = "bonfire/_BETA/action/LOAD_RULES_REQUEST";
export const LOAD_RULES_REQUEST_SUCCESS =
  "bonfire/_BETA/action/LOAD_RULES_REQUEST_SUCCESS";
export const LOAD_RULES_REQUEST_FAIL =
  "bonfire/_BETA/action/LOAD_RULES_REQUEST_FAIL";

export const ACTION_NOT_FOUND = "bonfire/_BETA/action/ACTION_NOT_FOUND";

export const ATTACHMENT_UPLOAD_SUCCESS =
  "bonfire/_BETA/action/ATTACHMENT_UPLOAD_SUCCESS";
export const ATTACHMENT_UPLOAD_FAIL =
  "bonfire/_BETA/action/ATTACHMENT_UPLOAD_FAIL";
